// Copyright 2018-2024 the Deno authors. All rights reserved. MIT license.
// This module is browser compatible.

import type { SemVer } from "./types.ts";
import { compare } from "./compare.ts";

/**
 * Greater than comparison for two SemVers.
 *
 * This is equal to `compare(version1, version2) > 0`.
 *
 * @example Usage
 * ```ts
 * import { parse, greaterThan } from "@std/semver";
 * import { assert } from "@std/assert";
 *
 * const version1 = parse("1.2.3");
 * const version2 = parse("1.2.4");
 *
 * assert(greaterThan(version2, version1));
 * assert(!greaterThan(version1, version2));
 * assert(!greaterThan(version1, version1));
 * ```
 *
 * @param version1 The first version to compare
 * @param version2 The second version to compare
 * @returns `true` if `version1` is greater than `version2`, `false` otherwise
 */
export function greaterThan(version1: SemVer, version2: SemVer): boolean {
  return compare(version1, version2) > 0;
}

// denoCacheMetadata={"headers":{"x-jsr-cache-id":"IAD","x-content-type-options":"nosniff","server":"UploadServer","date":"Fri, 08 Nov 2024 09:36:15 GMT","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","last-modified":"Wed, 04 Sep 2024 10:41:42 GMT","access-control-expose-headers":"*","cache-control":"public, max-age=31536000, immutable","expires":"Sat, 08 Nov 2025 09:36:15 GMT","x-goog-hash":"crc32c=nkMx6Q==,md5=c84PnxBeneTXfp5p/TPnnw==","cross-origin-resource-policy":"cross-origin","x-goog-stored-content-length":"948","accept-ranges":"bytes","age":"2026","x-robots-tag":"noindex","x-jsr-cache-status":"hit","etag":"\"73ce0f9f105e9de4d77e9e69fd33e79f\"","access-control-allow-origin":"*","x-goog-storage-class":"STANDARD","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","x-goog-generation":"1725446501973246","x-goog-metageneration":"1","x-goog-stored-content-encoding":"identity","x-guploader-uploadid":"AHmUCY050crRcjejEdeJu9Xhv4YKw50cu79Vrk8GYPtFQ1Niamg1ShwI-x-IoZIX_BsS9VMAoP0","content-length":"948","via":"1.1 google","content-type":"text/typescript"},"url":"https://jsr.io/@std/semver/1.0.3/greater_than.ts","time":1731060601}